import { Field } from 'formik'
import React from 'react'
import { IHiddenField } from '../@types/FormField'

export type IHiddenFieldProps = IHiddenField

export const testIds = {
  hiddenField: (id: string) => `form-field-hidden-field-${id}`,
}

export const Hidden = (field: IHiddenFieldProps) => {
  const { id } = field
  const fieldId = `${id}_field`

  return <Field id={fieldId} name={id} type="hidden" data-testid={testIds.hiddenField(id)} />
}
